import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class EventConfigurationService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getModal(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Variable/GetModel', data);
  }

  loadAddedParameters(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'Variable/LoadAddedParameters',
      data
    );
  }

  loadScript(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Variable/LoadScript', data);
  }

  loadScriptFault(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Variable/LoadScriptFault', data);
  }

  getDesktopFunctionsHistory(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'Variable/GetDesktopFunctionsHistory',
      data
    );
  }

  GetTEDList(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Variable/GetTEDList', data);
  }

  EvaluateExpression(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Variable/EvaluateGrammer', data);
  }

  EvaluateExpressionFault(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'Variable/EvaluateGrammerFault',
      data
    );
  }

}
